import {pack} from './pack'
import {unpack} from './unpack'
import type {CorePlugin} from '../../types'
import {createPluginFromSingleComponentPlugin} from '../../pluginsFactory'

export const rawExportPlugin: CorePlugin = createPluginFromSingleComponentPlugin({
    name: 'RawExportPlugin',
    pack,
    unpack
})
